export default __webpack_public_path__ + "static/media/coxsbazar.95a1dd98.jpg";